// extracted by mini-css-extract-plugin
export default {"footerLinks":"styles-module--footerLinks--3Cr95","footerLinksLine":"styles-module--footerLinksLine--3f8ll","linksContainer":"styles-module--linksContainer--3Q2wN"};